<template>
<div :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}]" :id="block.anchor ? block.anchor : ('block-' + block.id)" v-html="block.video"></div>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
export default {
    name        :   'FullscreenVideoBlock',
    mixins      :   [ BlockCommons ]
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/FullscreenVideoBlock.vue